export const FIELD_ICONS = {
  username: "bi bi-person-badge",
  email: "bi bi-envelope",
  name: "bi bi-person",
  roles: "bi bi-shield-check",
  branch_access: "bi bi-building",
  is_active: "bi bi-toggle-on",
  created: "bi bi-calendar-event",
  id: "bi bi-hash",
};

export function formatRelation(value) {
  if (value == null) return "—";
  if (typeof value === "string") return value;
  if (typeof value === "object" && value.name != null) return value.name;
  if (typeof value === "object" && value.id != null) return value.id;
  return "—";
}

export function formatDate(value) {
  if (!value) return "—";
  const d = new Date(value);
  return d.toLocaleDateString("en-US", { dateStyle: "medium" });
}

const CLIENT_FIELD_EXCLUDE = new Set([
  "id",
  "acl",
  "updated",
  "created",
  "creator",
  "editor",
  "user",
  "banks",
  "fullAddress",
  "isActive",
  "shippingStreet",
  "billingStreet",
  "clientOf",
]);

export function getDisplayableClientFields(schemaFields) {
  if (!schemaFields || typeof schemaFields !== "object") return [];
  return Object.entries(schemaFields).filter(
    ([key]) => !CLIENT_FIELD_EXCLUDE.has(key),
  );
}

export function groupClientFieldsBySection(schema) {
  const fields = schema?.fields;
  const sections = schema?.sections || {};
  if (!fields || typeof fields !== "object") return [];

  const groups = { General: [] };
  const sectionOrder = Object.keys(sections);

  for (const key of Object.keys(fields)) {
    if (CLIENT_FIELD_EXCLUDE.has(key)) continue;
    const fieldDef = fields[key];
    const sectionKey =
      fieldDef?.section != null && sections[fieldDef.section]
        ? fieldDef.section
        : "General";
    if (!groups[sectionKey]) groups[sectionKey] = [];
    groups[sectionKey].push([key, fieldDef]);
  }

  const result = [];
  const seen = new Set();
  for (const sectionKey of sectionOrder) {
    if (groups[sectionKey]?.length && !seen.has(sectionKey)) {
      seen.add(sectionKey);
      const sectionDef = sections[sectionKey] || {};
      result.push({
        sectionKey,
        label: sectionDef.label || sectionKey,
        icon: sectionDef.icon || "bi bi-card-text",
        fieldEntries: groups[sectionKey],
      });
    }
  }
  if (groups.General?.length) {
    result.push({
      sectionKey: "General",
      label: "General",
      icon: "bi bi-card-text",
      fieldEntries: groups.General,
    });
  }
  return result;
}

export function formatFieldValue(value, fieldDef) {
  if (value == null || value === "") return "—";
  const type = fieldDef?.type ?? fieldDef?._type;
  switch (type) {
    case "Date":
      return formatDate(value);
    case "Boolean":
      if (
        fieldDef?.label?.toLowerCase().includes("active") ||
        fieldDef?.label === "Active"
      ) {
        return value ? "Active" : "Inactive";
      }
      return value ? "Yes" : "No";
    case "Number":
      return typeof value === "number" ? value.toLocaleString() : String(value);
    case "Pointer":
    case "Relation":
      return formatRelation(value);
    case "String":
    default:
      return typeof value === "object" ? formatRelation(value) : String(value);
  }
}
